import { render, staticRenderFns } from "./StyleConfigPanel.vue?vue&type=template&id=23538a10&scoped=true"
import script from "./StyleConfigPanel.vue?vue&type=script&lang=js"
export * from "./StyleConfigPanel.vue?vue&type=script&lang=js"
import style0 from "./StyleConfigPanel.vue?vue&type=style&index=0&id=23538a10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23538a10",
  null
  
)

export default component.exports